// dev-mode (not embedded in customize.html) data
// go to the bottom to switch between caps and labels
/* eslint-disable no-unused-vars */

const caps = {
  designcode: '',
  config: {
    user: '',
    loginURL: '/signin',
    logURL: '/felog',
    lastDesignCookie: 'lastdesign',
    imageUploadURLGenerator: '/api/newBlobStoreURL',
    imagesListURL: '/userfiles/all',
    objDeleteURL: '/api/delete/',
    designsListURL: '/api/design/all/',
    designLoadURL: '/api/design/load/',
    designSaveURL: '/api/design/save',
  },
  product: 'caps',
  products: {
    caps: {
      id: 'BMCUSTOMCAP',
      name: 'caps',
      title: 'Custom Bottle Cap',
      sku: 'BMCUSTOMCAPWHITEOXY',
      color: 'whiteoxy',
      price: 0.20,
      weightper: 0.005,
      realsize: '1.4in',
      qtymin: 1,
      qtymax: 200000,
      qtystep: 1,
      qtysuggested: 60,
      toolimages: {
        background: '/resources/images/products/cap-whiteoxy-center.png',
        mask: '/resources/images/products/cap-whiteoxy-rim.png',
        transparent: '/resources/images/transparent.png',
        overlay: '',
        visibleW: 0.8,
        visibleH: 0.8,
        aspectratio: 1,
      },
      notice: '',
      confirmtext: `<p>This digital preview is closer to the size of a bottle cap. Please check that:</p>
          
          <ul class="">
            <li>text is legible,</li>
            <li>nothing is too small,</li>
            <li>position and size of image are correct,</li>
            <li>spelling is correct,</li>
            <li>quantity is enough, including extra for mishaps and souvenirs.</li>
          </ul>
          <p>We don't review your design before printing,            
            so make sure you're happy with it.
          </p>`,
      options: [
        {
          name: 'color',
          choices: [
            {
              name: 'white',
              title: 'White',
              humancolor: 'white',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPWHITE',
                price: 0.20,
                color: 'white',
                toolimages: {
                  background: '/resources/images/products/cap-white-center.png',
                  mask: '/resources/images/products/cap-white-rim.png',
                },
              },
              background: '/resources/images/tool/white.jpg',
              bgcolor: 'white',
              outofstock: '',
              hidden: true,
            },
            {
              name: 'whiteoxy',
              title: 'White Oxy',
              humancolor: 'white oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPWHITEOXY',
                price: 0.20,
                color: 'whiteoxy',
                toolimages: {
                  background: '/resources/images/products/cap-whiteoxy-center.png',
                  mask: '/resources/images/products/cap-whiteoxy-rim.png',
                },
              },
              background: '/resources/images/tool/white.jpg',
              bgcolor: 'white',
              outofstock: '',
              hidden: false,
            },
            {
              name: 'black',
              title: 'Black Oxy',
              humancolor: 'black',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPBLACK',
                price: 0.20,
                color: 'black',
                toolimages: {
                  background: '/resources/images/products/cap-black-center.png',
                  mask: '/resources/images/products/cap-black-rim.png',
                },
              },
              background: '/resources/images/tool/black.jpg',
              bgcolor: 'black',
              outofstock: '',
              hidden: true,
            },
            {
              name: 'blackoxy',
              title: 'Black Oxy',
              humancolor: 'black oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPBLACKOXY',
                price: 0.20,
                color: 'blackoxy',
                toolimages: {
                  background: '/resources/images/products/cap-blackoxy-center.png',
                  mask: '/resources/images/products/cap-blackoxy-rim.png',
                },
              },
              background: '/resources/images/tool/black.jpg',
              bgcolor: 'black',
              outofstock: '',
              hidden: false,
            },
            {
            },
            {
              name: 'silver',
              title: 'Silver',
              humancolor: 'silver',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPSILVER',
                price: 0.22,
                color: 'silver',
                toolimages: {
                  background: '/resources/images/products/cap-silver-center.png',
                  mask: '/resources/images/products/cap-silver-rim.png',
                },
              },
              background: '/resources/images/tool/silver.jpg',
              bgcolor: 'silver',
              outofstock: '',
              hidden: true,
            },
            {
              name: 'brightgold',
              title: 'Gold Oxy',
              humancolor: 'gold oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPBRIGHTGOLD',
                price: 0.22,
                color: 'brightgold',
                toolimages: {
                  background: '/resources/images/products/cap-brightgold-center.png',
                  mask: '/resources/images/products/cap-brightgold-rim.png',
                },
              },
              background: '/resources/images/tool/brightgold.jpg',
              bgcolor: 'yellow',
              outofstock: '',
              hidden: false,
            },
            {
              name: 'silveroxy',
              title: 'Silver Oxy',
              humancolor: 'silver oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPSILVEROXY',
                price: 0.22,
                color: 'silveroxy',
                toolimages: {
                  background: '/resources/images/products/cap-silveroxy-center.png',
                  mask: '/resources/images/products/cap-silveroxy-rim.png',
                },
              },
              background: '/resources/images/tool/silver.jpg',
              bgcolor: 'silver',
              outofstock: '',
              hidden: false,
            },
            {
              name: 'red',
              title: 'Red Oxy',
              humancolor: 'red oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPRED',
                price: 0.22,
                color: 'red',
                toolimages: {
                  background: '/resources/images/products/cap-red-center.png',
                  mask: '/resources/images/products/cap-red-rim.png',
                },
              },
              background: '/resources/images/tool/red.jpg',
              bgcolor: 'red',
              outofstock: '',
              hidden: false,
            },
            {
              name: 'redapple',
              title: 'Candy Apple Red Oxy',
              humancolor: 'candy apple red oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPREDAPPLE',
                price: 0.15,
                color: 'redapple',
                toolimages: {
                  background: '/resources/images/products/cap-redapple-center.png',
                  mask: '/resources/images/products/cap-redapple-rim.png',
                },
              },
              background: '/resources/images/tool/redapple.jpg',
              bgcolor: 'maroon',
              outofstock: '',
              hidden: true,
            },
            {
              name: 'orange',
              title: 'Orange Oxy',
              humancolor: 'orange oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPORANGE',
                price: 0.22,
                color: 'orange',
                toolimages: {
                  background: '/resources/images/products/cap-orange-center.png',
                  mask: '/resources/images/products/cap-orange-rim.png',
                },
              },
              background: '/resources/images/tool/orange.jpg',
              bgcolor: 'orange',
              outofstock: '',
              hidden: false,
            },
            {
              name: 'yellow',
              title: 'Yellow Oxy',
              humancolor: 'yellow oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPYELLOW',
                price: 0.22,
                color: 'yellow',
                toolimages: {
                  background: '/resources/images/products/cap-yellow-center.png',
                  mask: '/resources/images/products/cap-yellow-rim.png',
                },
              },
              background: '/resources/images/tool/yellow.jpg',
              bgcolor: 'gold',
              outofstock: '',
              hidden: false,
            },
            {
              name: 'blue',
              title: 'Blue Oxy',
              humancolor: 'blue oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPBLUE',
                price: 0.22,
                color: 'blue',
                toolimages: {
                  background: '/resources/images/products/cap-blue-center.png',
                  mask: '/resources/images/products/cap-blue-rim.png',
                },
              },
              background: '/resources/images/tool/blue.jpg',
              bgcolor: 'blue',
              outofstock: '',
              hidden: false,
            },
            {
              name: 'lightblue',
              title: 'Light Blue Oxy',
              humancolor: 'light blue',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPLIGHTBLUE',
                price: 0.22,
                color: 'lightblue',
                toolimages: {
                  background: '/resources/images/products/cap-lightblue-center.png',
                  mask: '/resources/images/products/cap-lightblue-rim.png',
                },
              },
              background: '/resources/images/tool/lightblue.jpg',
              bgcolor: 'cyan',
              outofstock: '',
              hidden: true,
            },
            {
              name: 'navyblue',
              title: 'Navy Blue Oxy',
              humancolor: 'navy blue oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPNAVYBLUE',
                price: 0.2,
                color: 'navyblue',
                toolimages: {
                  background: '/resources/images/products/cap-navyblue-center.png',
                  mask: '/resources/images/products/cap-navyblue-rim.png',
                },
              },
              background: '/resources/images/tool/navyblue.jpg',
              bgcolor: 'midnightblue',
              outofstock: '',
              hidden: false,
            },
            {
              name: 'pink',
              title: 'Pink Oxy',
              humancolor: 'pink oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPPINK',
                price: 0.22,
                color: 'pink',
                toolimages: {
                  background: '/resources/images/products/cap-pink-center.png',
                  mask: '/resources/images/products/cap-pink-rim.png',
                },
              },
              background: '/resources/images/tool/pink.jpg',
              bgcolor: 'pink',
              outofstock: '',
              hidden: true,
            },
            {
              name: 'green',
              title: 'Green',
              humancolor: 'green',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPGREEN',
                price: 0.22,
                color: 'green',
                toolimages: {
                  background: '/resources/images/products/cap-green-center.png',
                  mask: '/resources/images/products/cap-green-rim.png',
                },
              },
              background: '/resources/images/tool/green.jpg',
              bgcolor: 'green',
              outofstock: '',
              hidden: true,
            },
            {
              name: 'greenoxy',
              title: 'Green Oxy',
              humancolor: 'green oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPGREENOXY',
                price: 0.22,
                color: 'greenoxy',
                toolimages: {
                  background: '/resources/images/products/cap-greenoxy-center.png',
                  mask: '/resources/images/products/cap-greenoxy-rim.png',
                },
              },
              background: '/resources/images/tool/green.jpg',
              bgcolor: 'green',
              outofstock: '',
              hidden: false,
            },
            {
              name: 'oxygold',
              title: 'Gold Oxy',
              humancolor: 'gold oxy',
              cssclass: 'colorselectblock',
              overrides: {
                sku: 'BMCUSTOMCAPOXYGOLD',
                price: 0.22,
                color: 'oxygold',
                toolimages: {
                  background: '/resources/images/products/cap-oxygold-center.png',
                  mask: '/resources/images/products/cap-oxygold-rim.png',
                },
              },
              background: '/resources/images/tool/dullgold.jpg',
              bgcolor: 'goldenrod',
              outofstock: '',
              hidden: true,
            },
          ],
        },
      ],
    },
  },
};

const labels = {
  designcode: '',
  config: {
    user: 'test@bottlemark.com',
    loginURL: '/signin',
    logURL: '/felog',
    lastDesignCookie: 'lastdesign',
    imageUploadURLGenerator: '/api/newBlobStoreURL',
    imagesListURL: '/userfiles/all',
    objDeleteURL: '/api/delete/',
    designsListURL: '/api/design/all/',
    designLoadURL: '/api/design/load/',
    designSaveURL: '/api/design/save',
  },
  product: 'labels',
  products: {
    labels: {
      id: 'BMCUSTOMLABEL',
      title: 'Custom Label',
      sku: 'BMCUSTOMLABEL',
      color: '',
      price: 0.65,
      weightper: 0.005,
      realsize: '4in',
      qtymin: 4,
      qtymax: 3000,
      qtystep: 4,
      qtysuggested: 60,
      toolimages: {
        background: '/resources/images/products/label-bg.png',
        mask: '/resources/images/products/label-mask.png',
        transparent: '/resources/images/transparent.png',
        overlay: '/resources/images/products/label-help.png',
        visibleW: 0.8,
        visibleH: 0.8,
        aspectratio: 4.25 / 3.5,
      },
      notice: '',
      confirmtext: `<p>The design tool image is about the size of a label. Please check that:</p>
          
          <ul class="">
            <li>text is big enough to read and spelled correctly,</li>
            <li>position and size of image are correct,</li>
            <li>you have nothing important outside the safe zone,</li>
            <li>your design goes to the edge of the bleed line,</li>
            <li>quantity is enough, including extra for mishaps and souvenirs.</li>
          </ul>
          <p>We don't review your design before printing unless asked,
            so make sure you're happy with it.
          </p>`,
      options: [
      ],
    },
    neckers: {
      id: 'BMCUSTOMNECKER',
      title: 'Custom Necker',
      sku: 'BMCUSTOMNECKER',
      color: '',
      price: 0.65,
      weightper: 0.005,
      realsize: '4in',
      qtymin: 4,
      qtymax: 3000,
      qtystep: 4,
      qtysuggested: 60,
      toolimages: {
        background: '/resources/images/products/label-bg.png',
        mask: '/resources/images/products/necker-mask.png',
        transparent: '/resources/images/transparent.png',
        overlay: '/resources/images/products/necker-help.png',
        visibleW: 0.8,
        visibleH: 0.8,
        aspectratio: 2.0 / 1.5,
      },
      notice: '',
      confirmtext: `<p>The design tool image is about the size of a label. Please check that:</p>
          
          <ul class="">
            <li>text is big enough to read and spelled correctly,</li>
            <li>position and size of image are correct,</li>
            <li>you have nothing important outside the safe zone,</li>
            <li>your design goes to the edge of the bleed line,</li>
            <li>quantity is enough, including extra for mishaps and souvenirs.</li>
          </ul>
          <p>We don't review your design before printing unless asked,
            so make sure you're happy with it.
          </p>`,
      options: [], // we'll skip options for now, since this is only for neckers
    },
  },
};

const setup = caps;
// const setup = labels;
// setup.designcode = 'aghkZXZ-Tm9uZXITCxIGRGVzaWduGICAgICAgNMJDA';
export default setup;
